import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IframeDialogComponent } from '../../../site-container/iframe-dialog/iframe-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    footer = {
        col1: {
            title: 'Listique',
            links: [
                {
                    title: 'Home',
                    url: '/',
                },
                {
                    title: 'Careers',
                    url: '/magazine/careers',
                },
                {
                    title: 'Press',
                    url: '/magazine/press',
                },
                {
                    title: 'About Us',
                    url: '/about',
                },
                {
                    title: 'Contact Us',
                    url: '/contact',
                }
            ],
        },
        col2: {
            title: 'Everyone',
            links: [
                {
                    title: 'Search Directory',
                    url: '/categories',
                },
                {
                    title: 'Social Calendar',
                    url: '/events',
                },
                {
                    title: 'Magazine',
                    url: '/magazine',
                },
                {
                    title: 'What is Listique',
                    url: '/about',
                },
                {
                    title: 'How it works',
                    url: '/how-it-works',
                },
            ],
        },
        col3: {
            title: 'Members',
            links: [
                {
                    title: 'Forum',
                    url: '/magazine/forum',
                },
                {
                    title: 'Apply for membership',
                    url: 'https://forms.gle/1WeiqJxkrQvuAnJV6',
                    external: true
                },
            ],
        },
        col4: {
            title: 'Partners',
            links: [
                {
                    title: 'Forum',
                    url: '/magazine/forum',
                },
                {
                    title: 'Apply for partnership',
                    url: '/apply',
                },
                /*{
                    title: 'Login',
                    url: environment.membersUrl,
                    external: true
                },*/
            ],
        },
        col5: {
            title: 'Find us here',
            socials: [
                {
                    type: 'facebook',
                    url: environment.socials.facebook,
                    label: 'Listique on Facebook',
                },
                {
                    type: 'twitter',
                    url: environment.socials.twitter,
                    label: 'Listique on Twitter',
                },
                {
                    type: 'linkedin',
                    url: environment.socials.linkedin,
                    label: 'Listique on Linkedin',
                },
                {
                    type: 'instagram',
                    url: environment.socials.instagram,
                    label: 'Listique on Instagram',
                },
            ],
        },
    };
    currentYear = new Date().getFullYear();
    constructor(private dialog: MatDialog) { }

    ngOnInit() { }

    subscribeToMailingList() {
        this.dialog.open(IframeDialogComponent, {
            data: {
                url: 'https://eepurl.com/gU8bgP',
                width: '100%',
                height: '500px',
            },
            width: '500px',
            height: '500px',
            panelClass: ['no-pad-dialog', 'dialog-fullwidth-mobile']
        });
    }
}
